const captionOpen = 'caption_open';
const paragraphOpen = 'paragraph_open';
const paragraphClose = 'paragraph_close';
export function handleParagraphs(index, tokens) {
  var _tokens$index, _tokens, _tokens2;
  // make sure we have an opening and closing paragraph token
  if (((_tokens$index = tokens[index]) === null || _tokens$index === void 0 ? void 0 : _tokens$index.type) !== paragraphOpen && ((_tokens = tokens[index + 2]) === null || _tokens === void 0 ? void 0 : _tokens.type) !== paragraphClose) {
    return;
  }
  // remove the closing paragraph token from state.tokens so we don't add it into the acc
  // when we loop through the tokens
  ((_tokens2 = tokens[index + 2]) === null || _tokens2 === void 0 ? void 0 : _tokens2.type) === paragraphClose && tokens.splice(index + 2, 1);
  // return empty to prevent adding the opening token to the acc
  return;
}
export default function (md, idMap) {
  md.core.ruler.after('custom-block', 'caption', function (state) {
    state.tokens = state.tokens.reduce((acc, token, index) => {
      var _acc;
      const {
        type
      } = token;
      const isWithinCaption = ((_acc = acc[acc.length - 1]) === null || _acc === void 0 ? void 0 : _acc.type) === captionOpen;
      if (type === paragraphOpen && isWithinCaption) {
        /**
         * paragraph_open and paragraph_close tokens get automatically added by markdown-it
         * around text content. caption nodes do not allow paragraph nodes as children
         * so we need to prevent these tokens from being added to the acc
         */
        handleParagraphs(index, state.tokens);
      } else {
        acc.push(token);
      }
      return acc;
    }, []);
  });
}